export const selectFlatSelectListRow = (state: RootState) =>
	state.select.selectList.map((group) => group.row).flat()

export const selectIdLayerByIdSelect =
	(idSelect: number | null) => (state: RootState) =>
		!idSelect
			? undefined
			: selectFlatSelectListRow(state).find((i) => +i.id === +idSelect)?.idLayer
